/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Force TT Interphases font in the Broadcast theme
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Set all the font variables to TT Interphases
    const fontVars = [
      '--FONT-STACK-BODY',
      '--FONT-STACK-HEADING',
      '--FONT-STACK-SUBHEADING',
      '--FONT-STACK-NAV',
      '--BTN-FONT-STACK',
      '--font-body-family',
      '--font-heading-family'
    ];
    
    // Apply to root
    fontVars.forEach(varName => {
      document.documentElement.style.setProperty(varName, '"TT Interphases", sans-serif');
    });
    
    // Set mono font if used
    document.documentElement.style.setProperty('--FONT-STACK-MONO', '"TT Interphases Mono", monospace');
    document.documentElement.style.setProperty('--font-mono-family', '"TT Interphases Mono", monospace');
  });

  // Add SG25 overlay class to first section-double only
  document.addEventListener('DOMContentLoaded', function() {
    const doubleSections = document.querySelectorAll('.template-index section[data-section-type="double"]');
    if (doubleSections.length > 0) {
      doubleSections[0].classList.add('sg25-overlay-section');
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      var vsk = document.querySelector('variant-swatch-king');
      if (vsk && vsk.__proto__ && vsk.__proto__.clientSpecs && vsk.__proto__.clientSpecs.getSelectors) {
        console.log('Swatch root selector:', vsk.__proto__.clientSpecs.getSelectors().swatch_root.selector);
      }
    }, 3000);
  });

  /**
   * Detect sections that have vendor logo images and append "--vendor-v4" to their IDs
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Look for accordion sections that contain vendor logo images
    const accordionSections = document.querySelectorAll('section[data-section-type="faq"]');
    
    accordionSections.forEach(section => {
      // Look for image elements that might be vendor logos
      const vendorLogoImages = section.querySelectorAll('.faq-list__item-image img');
      
      // If we find any images in this accordion section
      if (vendorLogoImages.length > 0) {
        // Check if the section contains blocks with vendor metadata
        const hasVendorMeta = section.innerHTML.includes('product.metafields.custom.v4_vendor');
        
        if (hasVendorMeta) {
          // This is a vendor section, append the special class
          const currentId = section.getAttribute('id');
          if (currentId && !currentId.includes('--vendor-v4')) {
            section.setAttribute('id', `${currentId}--vendor-v4`);
          }
        }
      }
    });
  });

  /**
   * Handle zero-priced products:
   * 1. Change "Free" text to "Made to order"
   * 2. Replace purchase controls with a "Get a quote" button
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Function to handle zero-price products
    function handleZeroPriceProducts() {
      // Target product price elements
      const priceElements = document.querySelectorAll('[data-product-price]');
      
      priceElements.forEach(element => {
        if (element.textContent.trim() === 'Free') {
          // 1. Change "Free" to "Made to order"
          element.textContent = 'Made to order';
          
          // 2. Find and replace the purchase area
          const buttonsBlock = document.querySelector('.product__block--buttons');
          if (buttonsBlock) {
            // Get the product name from the product title element
            const productTitle = document.querySelector('.product__title')?.textContent.trim() || 
                               document.querySelector('h1')?.textContent.trim() || 
                               'Product';
            
            // Create replacement HTML for the quote button with formatted subject
            const quoteButtonHTML = `
              <a href="mailto:info@stylegarage.com?subject=Quote Request - ${encodeURIComponent(productTitle)}" 
                 class="btn btn--solid btn--primary" style="display: inline-block; width: 100%; text-align: center;">
                <span class="btn__text">Get a quote</span>
              </a>
            `;
            
            // Replace the entire content of the buttons block
            buttonsBlock.innerHTML = quoteButtonHTML;
          }
        }
      });
    }
    
    // Run initially
    handleZeroPriceProducts();
    
    // Also run when variants change (in case price updates)
    document.addEventListener('variant:change', function() {
      setTimeout(handleZeroPriceProducts, 10);
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
